/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-04-27 14:18:28
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-07-09 14:23:07
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelContentEditor/SalesChannelEditorAllProductPage/TopLeaderBoardBanner/index.tsx
 */
import React from 'react';
import css from './css.module.less';

import ErrorProcessingHOC from 'src/constrains/SalesChannelPreviewPageComponents/ErrorProcessingHOC';

import LinkImage from '@/src/constrains/LinkImg';
import Section from '@/src/constrains/SalesChannelPreviewPageComponents/SectionContainer';
import TipsAndSwitch from 'src/constrains/SalesChannelPreviewPageComponents/TipsAndSwitch';

import {
  EnumCollapseId,
  getCollapseOpenStatus,
  getCollapseValidationMsgDisplay,
  getSubmitStamp,
  getTopLeaderBoardBanner,
  onCollapseOpen,
  onErrorChange,
  onTopLeaderBoardBannerChange,
  onTopLeaderBoardBannerEnabledChange,
} from '../slice';

import { LinkModuleType } from '@/src/types/common/linkType';
import { useDispatch } from 'react-redux';
import { useSalesChannelIsMiniProgram } from 'src/constrains/SalesChannelHOC/useSalesChannel';
import { useI18n } from 'src/hooks/useRouterChange';
import Tip from 'src/pages/SalesChannelContentEditor/Components/DisabledSectionTip';
import { getI18nFromGeneral, i18nGet } from 'src/tools/tools';
import { topLeaderBoardBannerValidation } from '../tools';
const TopLeaderBoardBanner = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const isMini = useSalesChannelIsMiniProgram();
  const _d = useDispatch();
  const {
    data,
    specificError,
    salesChannelContentUuid,
    isPrimary,
    isConvertible,
    isResponsive,
  } = props;
  const { linkImageError = [], linkTypeError = [] } = specificError;

  const { enabled, linkModule } = data || {};
  const { linkType, uuid, label, action, linkImage } = linkModule || {};

  const handleOnEnabledChange = (enabled) => {
    _d(onTopLeaderBoardBannerEnabledChange({ enabled }));
  };
  const handleOnLinkChange = (link) => {
    _d(onTopLeaderBoardBannerChange(link));
  };
  const handleOnLinkImageChange = (linkImage) => {
    _d(onTopLeaderBoardBannerChange({ linkImage }));
  };

  const linkSet = () => {
    if (isMini) {
      return {
        // scopeVariables: { SalesChannelContent: salesChannelContentUuid },
        //linkTypeFilter: [LinkModuleType.None, LinkModuleType.SysModule],
        excludeLinkType: [
          {
            linkType: LinkModuleType.SysModule,
            groups: [
              // LinkModuleType.HomePage,
              // LinkModuleType.AllProducts,
              // LinkModuleType.Cart,
              // LinkModuleType.Profile,
              // LinkModuleType.CustomerService,

              LinkModuleType.ShareMiniProgram,
            ],
          },
          // {
          //   linkType: LinkModuleType.Product,
          // },
          // {
          //   linkType: LinkModuleType.Collection,
          // },
          // {
          //   linkType: LinkModuleType.ContentPage,
          // },
          // {
          //   linkType: LinkModuleType.LegalPage,
          // },
          // {
          //   linkType: LinkModuleType.LinkLibrary,
          // },
        ],
      };
    } else {
      return {
        scopeVariables: { SalesChannelContent: salesChannelContentUuid },
        linkTypeFilter: [
          LinkModuleType.Product,
          LinkModuleType.Collection,
          LinkModuleType.ContentPage,
          LinkModuleType.LinkLibrary,
          LinkModuleType.None,
          LinkModuleType.SysModule,
        ],
      };
    }
  };

  return (
    <React.Fragment>
      {isPrimary && !isResponsive && (
        <Section bottomBorder className={css.switchContainer}>
          <TipsAndSwitch
            enabled={enabled}
            onChange={handleOnEnabledChange}
            title={getI18n('general.hOCTitle.topLeaderBoardBanner')}
          />{' '}
        </Section>
      )}
      {!isPrimary && !enabled && (
        <Section>
          <Tip
            className={css.tipClassName}
            tip={getI18n(
              'salesChannelContent.index.enabletopleaderboardbanner',
            )}
          />
        </Section>
      )}

      {(enabled || isResponsive) && (
        <Section className={css.linkImageContainer}>
          <LinkImage
            imageErrorArray={linkImageError}
            linkTypeErrorArray={linkTypeError}
            linkSet={linkSet()}
            linkImage={linkImage}
            link={{ linkType, uuid, label, action }}
            title={getI18n('general.checkImgDraggableDisplay.title')}
            linkId={`link`}
            subtitle={getI18n('general.checkImgDraggableDisplay.subtitle')}
            linkOnChange={handleOnLinkChange}
            imgOnChange={handleOnLinkImageChange}
            showImageDisplaySetting={isConvertible}
          />
        </Section>
      )}
    </React.Fragment>
  );
};
export default ErrorProcessingHOC(TopLeaderBoardBanner, {
  getCollapseOpenStatus,
  onCollapseOpen,
  id: EnumCollapseId.topLeaderBoardBanner,
  getContent: getTopLeaderBoardBanner,
  title: getI18nFromGeneral('general.hOCTitle.topLeaderBoardBanner'),
  getErrorDisplay: getCollapseValidationMsgDisplay,
  onErrorChange,
  validation: topLeaderBoardBannerValidation,
  getSubmitStamp,
});
